module.exports = __webpack_public_path__ + "static/media/instagram.f9250684.svg";